module.exports = __webpack_public_path__ + "static/media/logo-ai.9bb79d91.svg";